
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import { WPXFormValue } from '@/components/templates/WPXForm';

  @Component
  export default class WPXForm extends Vue {
    @Prop({ type: WPXFormValue }) private readonly value!: WPXFormValue<unknown>
    @Prop({ type: String, default: 'wpxForm' }) private readonly formRef!: string
    @Prop({ type: Number, default: 290 }) private readonly dialogWidth!: number
    @Prop({ type: Boolean, default: true }) private readonly showTitle!: boolean

    private content: WPXFormValue<unknown> = this.value
  }
